// Copyright 2021 Sorama B.V.

import { Point3D, Region } from "datatypes/SoramaLocalApi";
import { RegionBasedVideoCalibration } from "./RegionBasedVideoCalibration";

export class FixedFovVideoCalibration extends RegionBasedVideoCalibration {
    constructor(
        position: Point3D,
        resolution: { width: number; height: number },
        distance: number,
        fieldOfView: number
    ) {
        super(
            resolution,
            distance,
            FixedFovVideoCalibration.computeVisibleRegion(
                position,
                fieldOfView,
                resolution.width / resolution.height,
                distance
            )
        );
    }

    private static computeVisibleRegion(position: Point3D, fov: number, aspectRatio: number, distance: number): Region {
        // Use a viewing angle of 90 degrees, when no video image is present
        const widthAngle = ((fov / 180) * Math.PI) / 2;
        const width = distance * Math.tan(widthAngle);

        return <Region>{
            centerX: position.x,
            centerY: position.y,
            height: width / aspectRatio,
            width: width,
        };
    }
}
